const mdSize = {height: 11, borderRadius: 'lg'}

export default {
    sizes: {
        md: {
            field: {...mdSize, px: 3},
            addon: mdSize
        }
    },
    baseStyle: {
        field: {
            backgroundColor: 'white !important',
            _focus: {
                borderColor: 'borderColor2'
            }
        }
    },
    variants: {
        outline: {
            field: {
                backgroundColor: 'white !important',
                borderColor: 'borderColor2'
            }
        },
        filled: {
            // we use filled variant for
            // search input
            field: {
                borderColor: 'gray.600',
                backgroundColor: 'white !important',
                _focus: {
                    backgroundColor: 'white'
                },
                _hover: {
                    backgroundColor: 'white',
                    _focus: {
                        backgroundColor: 'white'
                    }
                },
                _placeholder: {
                    color: 'gray.700'
                }
            }
        }
    }
}
